module.exports = __webpack_public_path__ + "img/index00.319f0660.png";